<template>
  <div :is="tag" :to="to" v-ripple :class="[baseCss, `shadow-${elevation}`, block ? 'block' : ['inline-block', 'align-middle'], 'font-semibold', 'select-none', rounded ? ['rounded', 'overflow-hidden'] : null, fancy ? ['rounded-full', 'overflow-hidden'] : null]" :style="{fontSize}">
    <table-layout y-align="middle" tag="span">
      <row tag="span">
        <cell v-if="icon" :style="iconCss" :class="['p-1']" tag="span">
          <icon :name="icon" :provider="iconProvider" :style="{color: subjectColor}" :size="iconSize" />
        </cell>
        <cell v-if="subject" v-html="subject" :style="subjectCss" :class="[icon ? 'pr-1' : 'px-1', 'py-1', 'whitespace-nowrap']" tag="span" />
        <cell v-if="status" v-html="status" :style="{background: statusBgColor, color: statusColor, width: block ? '100%' : null}" :class="['p-1', 'whitespace-nowrap']" tag="span" />
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'BadgeGenerator',
  mixins: [
    methods,
    props
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('badge-generator', [])
    }
  },
  computed: {
    subjectCss () {
      return {
        background: this.subjectBgColor,
        color: this.subjectColor
      }
    },
    iconCss () {
      return {
        background: this.subjectBgColor,
        color: this.subjectColor,
        width: this.block ? this.iconSize + 'em' : null
      }
    }
  },
  props: {
    icon: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    block: {
      type: Boolean
    },
    fancy: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'span'
    },
    iconSize: {
      type: Number,
      default: 1.4
    },
    fontSize: {
      type: String,
      default: '11px'
    },
    rounded: {
      type: Boolean,
      default: true
    },
    subject: {
      type: [String, Number],
      required: true
    },
    status: {
      type: [String, Number],
      required: true
    },
    subjectBgColor: {
      type: String,
      default: '#616161'
    },
    statusBgColor: {
      type: String,
      default: '#e31818'
    },
    subjectColor: {
      type: String,
      default: '#fff'
    },
    statusColor: {
      type: String,
      default: '#fff'
    },
    to: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/badge-generator/badge-generator.vue